import { useEffect } from "react";

export const usePageMeta = (title: string, description: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    let meta = document.querySelector(
      'meta[name="description"]'
    ) as HTMLMetaElement | null;
    const created = !meta;
    const previousDescription = meta?.getAttribute("content") ?? "";

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", description);

    return () => {
      document.title = previousTitle;

      if (!meta) return;

      if (created) {
        meta.remove();
        return;
      }

      meta.setAttribute("content", previousDescription);
    };
  }, [description, title]);
};
